export const defaultApiUrl = 'https://recipelogprd-v2.azurewebsites.net'
